const LOCATION_MILES_ARRAY = [
  { miles: "Any", distance: "any" },
  { miles: "20 miles", distance: "20" },
  { miles: "50 miles", distance: "50" },
  { miles: "100 miles", distance: "100" },
  { miles: "200 miles", distance: "200" },
];

const UNI_SORTING_MOCKDATA = [
  {
    id: "Uni1",
    name: "Universities A - C",
    sortingValue: "A-B-C",
    displayHeading: "A - C",
    unilist: [],
  },
  {
    id: "Uni2",
    name: "Universities D - H",
    sortingValue: "D-E-F-G-H",
    displayHeading: "D - H",
    unilist: [],
  },
  {
    id: "Uni3",
    name: "Universities I - M",
    sortingValue: "I-J-K-L-M",
    displayHeading: "I - M",
    unilist: [],
  },
  {
    id: "Uni4",
    name: "Universities N - P",
    sortingValue: "N-O-P-Q-P",
    displayHeading: "N - P",
    unilist: [],
  },
  {
    id: "Uni5",
    name: "Universities Q - U",
    sortingValue: "Q-R-S-T-U",
    displayHeading: "Q - U",
    unilist: [],
  },
  {
    id: "Uni6",
    name: "Universities V - Z",
    sortingValue: "V-W-X-Y-Z",
    displayHeading: "V - Z",
    unilist: [],
  },
];

const GET_FILTER_PRIORITY = (isQualification?: boolean) => {
  const whatunifilter = [
    "q",
    "subject",
    "university",
    "location",
    "study-method",
    "study-mode",
    "year",
    "month",
    "distance",
    "postcode",
    "university-group",
    "score",
    "location-type",
  ];
  const pgsFilter = [
    "keyword",
    "course",
    "university",
    "qualification",
    "location",
    "study_method",
    "study_mode",
    "year",
    "month",
    "distance",
    "postcode",
    "university_group",
    "score",
    "location_type",
  ];
  const whatuniSrFilters = [
    ...whatunifilter,
    "russell-group",
    "sort",
    "postcode",
  ];
  const whatuniPrFilters = [...whatunifilter, "sort", "postcode"];
  const pgsSrFilters = [...pgsFilter, "russell_group", "sort", "postcode"];
  const pgsPrFilters = [...pgsFilter, "sort", "postcode"];
  if (process.env.PROJECT === "Whatuni" && isQualification) {
    return [...whatuniPrFilters];
  } else if (process.env.PROJECT === "Whatuni" && !isQualification) {
    return [...whatuniSrFilters];
  } else if (process.env.PROJECT === "Pgs" && isQualification) {
    return [...pgsPrFilters];
  } else {
    return [...pgsSrFilters];
  }
};

const IGNORED_PREFIXES = [
  "The University of",
  "University of the",
  "The University for",
  "University for",
  "University of",
  "University",
  "The",
];

const getUniversityFirstLetter = (universityName: string): string => {
  let name = universityName?.trim()?.replace(/-/g, " ");
  for (const prefix of IGNORED_PREFIXES) {
    if (name?.toLowerCase()?.startsWith(prefix?.toLowerCase())) {
      name = name?.slice(prefix?.length)?.trim();
      break;
    }
  }
  return name.charAt(0).toUpperCase();
};

const REFRESH_PARAMETERS = [
  "degree-courses",
  "postgraduate-courses",
  "foundation-degree-courses",
  "access-foundation-courses",
  "hnd-hnc-courses",
  "pgs/search",
  "search",
  "csearch",
];

export {
  UNI_SORTING_MOCKDATA,
  LOCATION_MILES_ARRAY,
  IGNORED_PREFIXES,
  REFRESH_PARAMETERS,
  GET_FILTER_PRIORITY,
  getUniversityFirstLetter,
};
